import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { LoginComponent } from './login/login.component';
import { DevicesComponent } from './devices/devices.component';
import { ControlComponent } from './control/control.component';
import { UserComponent } from './user/user.component';
import { DashboardComponent } from './control/dashboard/dashboard.component';
import { GroupsComponent } from './user/groups/groups.component';
import { ProfileComponent } from './user/profile/profile.component';
import { RecentActivitiesComponent } from './user/recent-activities/recent-activities.component';
import { ScreenshotsComponent } from './control/screenshots/screenshots.component';
import { ReportComponent } from './report/report.component';
import { AutomationComponent } from './control/automation/automation.component';
import { AdvancedComponent } from './control/advanced/advanced.component';
import { ExplorerComponent } from './control/explorer/explorer.component';
import { InfoComponent } from './control/info/info.component';
import { DeviceControlComponent } from './control/device-control/device-control.component';
import { DeviceScreenComponent } from './control/device-control/device-screen/device-screen.component';
import { DeviceContextMenuComponent } from './control/device-control/device-context-menu/device-context-menu.component';
import { SettingsComponent } from './settings/settings.component';
import { GeneralComponent } from './settings/general/general.component';
import { GroupComponent } from './settings/group/group.component';
import { KeysComponent } from './settings/keys/keys.component';
import { UsersComponent } from './settings/users/users.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ProteanBrowserComponent } from './protean-browser/protean-browser.component';
import { WebScreenComponent } from './protean-browser/web-screen/web-screen.component';
import { MultiDeviceComponent } from './control/multi-device/multi-device.component';
import { MultiExecutionComponent } from './control/multi-execution/multi-execution.component';
import { SlaveSelectionComponent } from './control/slave-selection/slave-selection.component';
import { InspectorComponent } from './inspector/inspector.component';

const routes: Routes = [
  { path: '', redirectTo: 'devices', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'forgotpassword', component: ForgotPasswordComponent },
  { path: 'devices', component: DevicesComponent, canActivate: [authGuard] },
  { path: 'report', component: ReportComponent, canActivate: [authGuard] },
  { path: 'browser', component: ProteanBrowserComponent, canActivate: [authGuard] },
  { path: 'webscreen/:id', component: WebScreenComponent, canActivate: [authGuard] },
  {
    path: 'control/:id', component: ControlComponent, canActivate: [authGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent, canActivate: [authGuard] },
      { path: 'screenshots', component: ScreenshotsComponent, canActivate: [authGuard] },
      { path: 'automation', component: AutomationComponent, canActivate: [authGuard] },
      { path: 'advanced', component: AdvancedComponent, canActivate: [authGuard] },
      { path: 'explorer', component: ExplorerComponent, canActivate: [authGuard] },
      { path: 'info', component: InfoComponent, canActivate: [authGuard] },
      {
        path: 'device-control', component: DeviceControlComponent, canActivate: [authGuard],
        children: [
          { path: 'device-screen', component: DeviceScreenComponent, canActivate: [authGuard] },
          { path: 'device-context-menu', component: DeviceContextMenuComponent, canActivate: [authGuard] },
        ]
      },
    ]
  },
  { path: 'control/:id/multi-device/:deviceIds', component: MultiDeviceComponent, canActivate: [authGuard] },
  { path: 'control/:id/multi-execution/:encryptedDevices', component: MultiExecutionComponent, canActivate: [authGuard] },
  { path: 'control/:id/slave-selection', component: SlaveSelectionComponent, canActivate: [authGuard] },
  // { path: 'control/:id/inspector/:sessionId', component: InspectorComponent, canActivate: [authGuard] },
  // {
  //   path: 'inspector',
  //   loadChildren: () => import('./control/inspector/inspector.module').then(m => m.InspectorModule)
  // }
  { path: 'inspector/:serial/:sessionId', component: InspectorComponent, canActivate: [authGuard] },
  {
    path: 'inspector',
    loadChildren: () => import('./inspector/inspector.module').then(m => m.InspectorModule)
  }
  ,
  {
    path: 'user', component: UserComponent, canActivate: [authGuard], children:
      [
        { path: 'profile', component: ProfileComponent, canActivate: [authGuard] },
        { path: 'grouplist', component: GroupsComponent, canActivate: [authGuard] },
        { path: 'recentActivities', component: RecentActivitiesComponent, canActivate: [authGuard] }
      ]
  },
  {
    path: 'settings', component: SettingsComponent, canActivate: [authGuard], children:
      [
        { path: 'device', component: ProfileComponent, canActivate: [authGuard] },
        { path: 'general', component: GeneralComponent, canActivate: [authGuard] },
        { path: 'group', component: GroupComponent, canActivate: [authGuard] },
        { path: 'keys', component: KeysComponent, canActivate: [authGuard] },
        { path: 'users', component: UsersComponent, canActivate: [authGuard] }
      ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
